import styled from 'styled-components'
import { LevelRatingResultCardProps } from '@app.feature/exam/gsat2024-2/types/levelRatingType'

export interface ResultCardDesktopProps extends LevelRatingResultCardProps {}

const ResultCardDesktop = ({
  cardTitle,
  description,
  mainDataText,
  subText,
}: ResultCardDesktopProps) => {
  return (
    <StyledWrapper>
      {cardTitle && <label>{cardTitle}</label>}
      <div className="data-text-layout">
        <strong>{mainDataText}</strong>
        {subText && <p>{subText}</p>}
      </div>
      {description && <p className="description-text">{description}</p>}
    </StyledWrapper>
  )
}

export default ResultCardDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 358px;
  height: 156px;
  border-radius: 8px;
  background-color: #fafafa;

  > label {
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    color: #333;
    margin-bottom: 6px;
  }

  > .data-text-layout {
    display: flex;
    align-items: center;
    gap: 4px;

    > strong {
      font-size: 28px;
      font-weight: bold;
      letter-spacing: -1.12px;
      color: #004eff;
    }

    > p {
      font-size: 18px;
      font-weight: normal;
      letter-spacing: -0.72px;
      color: #666666;
    }
  }

  .description-text {
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    color: #666666;
    margin-top: 6px;
  }
`
